import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMq from 'vue-mq'
import DirectiveBar from '@/mixins/DirectiveBar.js'
require('intersection-observer')

Vue.directive('bar', DirectiveBar)

Vue.config.productionTip = false

Vue.use(VueMq, {
  breakpoints: {
    sm: 800,
    lg: Infinity
  }
})

const app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

export default app
